export function UnlimitedCount({ current, icon }) {
	return (
		<div
			className="w-[84px] h-[40px] justify-evenly border-solid border flex flex-row items-center"
			style={{
				backgroundImage: `url(/liveGameIcons/BACKGROUND.png)`,
				borderColor: 'var(--main-color)',
			}}
		>
			<div className="flex flex-row items-center max-w-[47px] justify-end mr-[2px]">
				<h1 className="text-white text-lg">{current}</h1>
			</div>
			<img className="w-[34px] h-[34px]" src={icon} alt="" />
		</div>
	)
}
